import actionTypes from './actionTypes'

const onboardingActions = {
	initialize(location, params) {
		return {
			type: actionTypes.ONBOARDING_INITIALIZE,
			location,
			params,
		}
	},
	changeStep(step, fromNumberButton) {
		return {
			type: actionTypes.ONBOARDING_CHANGE_STEP,
			step: step || 0,
			fromNumberButton,
		}
	},
	navigateToStep(step, fromNumberButton) {
		return {
			type: actionTypes.ONBOARDING_NAVIGATE_TO_STEP,
			step,
			fromNumberButton,
		}
	},
	saveGrades() {
		return {
			type: actionTypes.ONBOARDING_SAVE_GRADES,
		}
	},
	saveInterests() {
		return {
			type: actionTypes.ONBOARDING_SAVE_INTERESTS,
		}
	},
	selectInterest(id) {
		return {
			type: actionTypes.ONBOARDING_SELECT_INTERESTS,
			id,
		}
	},
	selectTechnology(id) {
		return {
			type: actionTypes.ONBOARDING_SELECT_TECHNOLOGY,
			id,
		}
	},
	saveSubjects() {
		return {
			type: actionTypes.ONBOARDING_SAVE_SUBJECTS,
		}
	},
	saveTechnology() {
		return {
			type: actionTypes.ONBOARDING_SAVE_TECHNOLOGY,
		}
	},
	gradesSaved(grades) {
		return {
			type: actionTypes.ONBOARDING_GRADES_SAVED,
			grades,
		}
	},
	subjectsSaved(subjects) {
		return {
			type: actionTypes.ONBOARDING_SUBJECTS_SAVED,
			subjects,
		}
	},
	getLessons() {
		return {
			type: actionTypes.ONBOARDING_GET_LESSONS,
		}
	},
	resetTransitioning() {
		return {
			type: actionTypes.ONBOARDING_RESET_STEP_TRANSITION,
		}
	},
	lessonImageLoaded() {
		return {
			type: actionTypes.ONBOARDING_LESSON_ASSET_LOADED,
		}
	},
	animationLoopComplete() {
		return {
			type: actionTypes.ONBOARDING_LOOP_COMPLETE,
		}
	},
	animationLoadingComplete() {
		return {
			type: actionTypes.ONBOARDING_LOADING_COMPLETE,
		}
	},
	updateGrades(grades) {
		return {
			type: actionTypes.ONBOARDING_GRADES_UPDATED,
			grades,
		}
	},
	updateSubjects(subjects) {
		return {
			type: actionTypes.ONBOARDING_SUBJECTS_UPDATED,
			subjects,
		}
	},
	lessonSelected(entityUID) {
		return {
			type: actionTypes.ONBOARDING_LESSON_SELECTED,
			entityUID,
		}
	},
	addToLibrary(subjects) {
		return {
			type: actionTypes.ONBOARDING_ADD_TO_LIBRARY,
			subjects,
		}
	},
	previewLesson(previewID) {
		return {
			type: actionTypes.ONBOARDING_PREVIEW_SELECTED,
			previewID,
		}
	},
	closePreview() {
		return {
			type: actionTypes.ONBOARDING_PREVIEW_CLOSE,
		}
	},
	skipClicked(step, fromStore) {
		return {
			type: actionTypes.ONBOARDING_SKIP,
			step,
			fromStore,
		}
	},
}

export default onboardingActions
